export const BRAND_NAME_KEYS = [
  "jacuzzi-swim-spas",
  "jacuzzi-hot-tubs",
  "sundance-spas",
  "dimension-one-spas",
];

export const codeTemplate = `<iframe
  title="Brand3D Embedded Experience"
  src="%embed_address%/%id%%options%"
  seamless
  width="100%"
  height="700px"
  allow="clipboard-read; clipboard-write"
  class="brand3d-embedded-iframe"
></iframe>
<style>
  .brand3d-embedded-iframe {
    border: none;
    width: 100%;
    /* height: 50vh; /* setting height is optional */
  }
</style>`;
